import {remove} from "lodash/array";

export default class ReadMore {
    constructor(contentElement, toggleElement) {
        this.contentElement = contentElement;
        this.toggleElement = toggleElement;

        // Initialize the state
        this.isExpanded = false;

        // Bind the click event to the toggle method
        this.toggleElement.addEventListener('click', () => this.toggle());
    }

    toggle() {
        this.isExpanded = !this.isExpanded;

        // Update the view based on the current state
        this.updateView();
    }

    updateView() {
        if (this.isExpanded) {
            this.contentElement.classList.toggle('is-expanded')
            this.toggleElement.textContent = 'Lees minder';
        } else {
            this.contentElement.classList.toggle('is-expanded');
            this.toggleElement.textContent = 'Lees meer';
        }
    }
}
